var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39905 19.4954C3.39905 19.4954 3.37685 20 3.92274 20C4.60186 20 10.2246 19.9934 10.2246 19.9934L10.2338 15.3309C10.2338 15.3309 10.145 14.5623 10.9712 14.5623H13.5859C14.563 14.5623 14.5029 15.3309 14.5029 15.3309L14.4918 19.9783C14.4918 19.9783 19.823 19.9783 20.6603 19.9783C21.3533 19.9783 21.3219 19.3501 21.3219 19.3501V10.7544L12.6283 3.77197L3.39905 10.7544V19.4954Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1044C0 10.1044 0.783679 11.4085 2.4926 10.1044L12.7054 2.30326L22.2807 10.056C24.2589 11.3442 25 10.056 25 10.056L12.7054 0L0 10.1044Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0484 2.28467H19.5854L19.5956 4.98141L22.0484 6.86027V2.28467Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4382c68305da55e10b0c92e9cb061384.svg";
export { ForwardRef as ReactComponent };